














import {
  Vue,
  Component,
  Prop,
  Ref,
  Emit,
  Provide
} from 'vue-property-decorator'
import { FormDef, FieldDef } from '@/types'
import EditForm from '../edit-form/index.vue'

@Component({
  components: {}
})
export default class EditFormGroup extends Vue {
  @Emit() submit (params: Array<Record<string | number, any>>) {
    /* */
  }

  @Prop(Boolean) disabled!: boolean

  @Prop() handleCancel!: any
  @Prop() onExtraClick!: any

  @Prop() resetCb!: any

  @Prop(Boolean) hide!: boolean

  @Prop(String) confirmText!: boolean
  @Prop(String) extraText!: boolean

  @Prop({ type: Boolean, default: false }) isCancelBtn!: boolean
  @Prop({ type: Boolean, default: false }) isExtraBtn!: boolean

  @Prop({ type: Boolean, default: true }) isResetBtn!: boolean

  @Prop({ type: Boolean, default: false }) loading!: boolean

  forms: EditForm[] = []

  @Provide() getEditFormGroup () {
    return this
  }

  forSubmit (): Promise<Array<Record<string | number, any>>> {
    return Promise.all(this.forms.map(v => v.forSubmit()))
      .catch((e: any) => {
        this.$message.warning('请填写完整信息后提交。')
        return Promise.reject(e)
      })
  }

  onSubmit () {
    this.forSubmit().then((params: Array<Record<string | number, any>>) => {
      this.submit(params)
    })
  }

  onReset () {
    this.forms.forEach(v => {
      v.onReset()
      this.resetCb && this.resetCb()
    })
  }

  onCancel () {
    if (this.handleCancel) {
      this.handleCancel()
    } else {
      this.$router.go(-1)
    }
  }
}
